/**
 * Details Components - Context-switching detail widgets for Copilot panel
 *
 * NEW (Schema-driven):
 * - DetailsPanel: Generic, schema-driven detail view for any entity type
 * - SectionRenderer: Dispatches to appropriate section component
 *
 * LEGACY (Entity-specific - to be deprecated):
 * - ProjectDetails, RFQDetails, PODetails, VendorDetails, ProductDetails, VendorResponseDetails
 *
 * Shared components for building detail UIs:
 * - StatusBadge: Configurable status badge with type-based colors
 * - SectionHeader: Consistent section headers
 * - VendorContactsList: Vendor contacts with loading state
 * - LineItemsTable: Tabular line item display
 * - OdooLink: External link to Odoo records
 * - LoadingState: Inline loading indicator
 *
 * @layer presentation
 * @arch_domain copilot
 */

// NEW: Schema-driven components
export { DetailsPanel } from './details-panel';
export { SectionRenderer } from './section-renderer';
export { EntityDetailsLoader } from './entity-details-loader';

// LEGACY: Entity-specific components (to be deprecated)
export { ProjectDetails } from './project-details';
export { RFQDetails } from './rfq-details';
export { PODetails } from './po-details';
export { VendorDetails } from './vendor-details';
export { ProductDetails } from './product-details';
export { VendorResponseDetails } from './vendor-response-details';

// Testing mode components
export { TestCaseDetails } from './test-case-details';

// Shared components (for building custom detail UIs)
export {
  StatusBadge,
  SectionHeader,
  VendorContactsList,
  LoadingState,
  LineItemsTable,
  OdooLink,
  type StatusType,
} from './shared';

// Section components and types
export * from './sections';
